import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth';
import { Button, Field, Input } from '../ui';

// Só aceita caminhos internos (evita open-redirect para sites externos).
function safeNext(raw: string | null): string {
  if (!raw) return '/';
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/\\')) return '/';
  return raw;
}

export function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const next = useMemo(() => safeNext(new URLSearchParams(window.location.search).get('next')), []);
  const [email, setEmail] = useState('');
  const [pw, setPw] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [googleOn, setGoogleOn] = useState(false);

  useEffect(() => {
    fetch('/v1/auth/providers', { credentials: 'include' }).then((r) => r.json()).then((d) => setGoogleOn(!!d.google)).catch(() => undefined);
    const e = new URLSearchParams(window.location.search).get('error');
    if (e) setErr(e === 'not_registered' ? 'Esta conta Google não está cadastrada — peça acesso a um admin.' : 'Falha no login com Google.');
  }, []);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await login(email, pw);
      // /v1/* é servido pela API (ex.: doc-view HTML), não é rota do SPA → hard redirect.
      if (next.startsWith('/v1/')) window.location.assign(next);
      else nav(next, { replace: true });
    } catch (e) {
      const api = e as { status?: number };
      setErr(api.status === 401 ? 'Credenciais inválidas' : 'Falha ao entrar');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={submit}>
        <div className="login-brand">
          <div className="sidebar-brand-mark" aria-hidden>b</div>
          <strong style={{ fontSize: 'var(--font-size-lg)' }}>Neo-Pilots</strong>
        </div>
        <h1>Entrar</h1>
        <Field label="E-mail">
          <Input
            type="email"
            autoFocus
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Field>
        <Field label="Senha" error={err ?? undefined}>
          <Input
            type="password"
            required
            value={pw}
            onChange={(e) => setPw(e.target.value)}
          />
        </Field>
        <Button type="submit" variant="primary" size="lg" disabled={busy}>
          {busy ? 'Entrando…' : 'Entrar'}
        </Button>
        {googleOn && (
          <Button type="button" variant="ghost" size="lg" onClick={() => { window.location.href = next !== '/' ? `/v1/auth/google?next=${encodeURIComponent(next)}` : '/v1/auth/google'; }} style={{ marginTop: 8 }}>
            Entrar com Google
          </Button>
        )}
      </form>
    </div>
  );
}
